module.exports = __webpack_public_path__ + "static/75gde-4aacbee4040f5fd78db7d1198ef3a258.gif";